var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"py-10"},[_c('v-row',[_c('v-col',_vm._l((_vm.allRelations),function(rel){return _c('content-element',{key:rel.data.id,attrs:{"id":rel.data.id,"type":rel.data.type,"links":rel.data.links,"meta":_vm.meta,"attributes":rel.data.attributes,"relationships":rel.data.relationships}})}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }